var _excluded = ["colorName"];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import * as React from 'react';
import { colors } from '../../@theme/colors';
import Button from '@mui/material/Button';
var ButtonLink = function ButtonLink(_ref) {
  var _ref$colorName = _ref.colorName,
    colorName = _ref$colorName === void 0 ? 'purple' : _ref$colorName,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = {
    purple: colors.WomCorp,
    bubblegum: colors.WomCTA
  }[colorName];
  var buttonStylesProps = {
    textDecorationColor: color,
    color: color,
    ':hover': {
      background: 'none'
    },
    textTransform: 'none',
    fontWeight: 'normal',
    textDecorationLine: 'underline',
    fontSize: '13px',
    padding: '0'
  };
  return React.createElement(Button, _extends({
    sx: buttonStylesProps,
    variant: "text",
    disableRipple: true
  }, props));
};
export default ButtonLink;